import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  forwardRef,
} from "@angular/core";
import { debounceTime, Subject, Subscription } from "rxjs";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { EventManagerService } from "../../service/event-manager.service";
import DiacriticUtil from "../../utils/diacritic.util";
declare let $;
@Component({
  selector: "dropdown",
  templateUrl: "./dropdown-search.component.html",
  styleUrls: ["./dropdown-search.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownSearchComponent),
      multi: true,
    },
  ],
})
export class DropdownSearchComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @Input() title: string;
  @Input() list: any;
  @Input() disabled: any;
  @Input() isHaveContent = false;
  @Output() result: EventEmitter<any> = new EventEmitter();
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  @Output() valuesChange: EventEmitter<any> = new EventEmitter();
  @Output() resultGroup: EventEmitter<any> = new EventEmitter();
  @Output() emitSearch: EventEmitter<any> = new EventEmitter();
  @Output() firstClick: EventEmitter<any> = new EventEmitter();
  @Input() value: any = null;
  @Input() field: string = "name";
  @Input() key: string = "id";
  @Input() rowTemplate: TemplateRef<any>;
  @Input() name: any = "";
  @Input() multiple: any = false;
  @Input() isError: boolean = false;
  @Input() backgroundColor = "transparent";
  @Input() minWidth = "120px";
  @Input() values: any[] = [];
  @Input() optionGroups: OptionGroup[] = [];
  @Input() isLong: boolean = false;
  @Input() tooMany: boolean = false;
  @Input() showSelectedTooltip: boolean = false;
  defaultItem: any = { id: undefined };
  @Input() isNoAll: any = true;
  @Input() isEmitSearch = false;
  isSelectAll: boolean = false;
  color: string = "";
  textSearch: string = "";
  groups: any[] = [];
  openDropdownlist = false;
  isFirstClick: boolean = true;
  debouncSearch$ = new Subject();
  eventSubscribers?: Subscription[] = [];
  id =
    "myDropdown" +
    Math.floor(Math.random() * 1000) +
    Math.floor(Math.random() * 999);
  onChange: any = () => {};
  onTouched: any = () => {};
  private contentPlaceholder: Comment | null = null;
  private repositionHandler = () => this.positionDropdown();
  constructor(
    private eventManager: EventManagerService,
    private cdf: ChangeDetectorRef,
  ) {}

  get selectedTooltipText(): string {
    if (!this.showSelectedTooltip) {
      return "";
    }

    return this.name || this.title || "";
  }
  ngOnInit() {
    this.eventSubscribers = [
      this.eventManager.subscribe("selected-item", (res) => {
        if (res.content) {
          this.chooseValue(res.content);
        }
      }),
      this.eventManager.subscribe("body-click", (res) => {
        const event = res.content.event;
        if (
          $(event.target).closest("#" + this.id).length === 0 &&
          $(event.target).closest("#action" + this.id).length === 0
        ) {
          this.openDropdownlist = false;
          const contentEl = document.getElementById(this.id);
          if (contentEl && contentEl.classList.contains("show")) {
            contentEl.classList.remove("show");
            this.hideDropdownPortal();
          }
        } else {
          this.openDropdownlist = true;
        }
      }),
      this.debouncSearch$.pipe(debounceTime(1000)).subscribe((event) => {
        return this.filter();
      }),
    ];
  }
  ngAfterViewInit() {
    $("select").click(function (e) {
      e.preventDefault();
    });
    this.cutName();
  }
  ngOnDestroy(): void {
    this.hideDropdownPortal();
    this.eventManager.destroys(this.eventSubscribers);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.list && changes.list.currentValue) {
      this.onChangeList(changes.list.currentValue);
    }
    if (changes.value) {
      this.onChangeValue();
    }
    if (changes.values) {
      this.onChangeValues();
    }
    if (changes.optionGroups) {
      this.onChangeOptionGroup();
    }
    this.cutName();
  }
  onChangeList(currentValue) {
    this.list = JSON.parse(JSON.stringify(currentValue || []));
    if (this.value || this.value === 0) {
      this.onChangeValue();
    } else if (this.values) {
      this.onChangeValues();
    }
    if (this.optionGroups.length) {
      this.onChangeOptionGroup();
    }
    this.cutName();
  }
  onChangeValue() {
    if (!this.value && this.value !== 0) {
      this.name = this.title;
    }
    if ((this.value || this.value === 0) && this.list && this.list.length > 0) {
      const find =
        this.list.find(
          (item) =>
            item[this.key] === this.value ||
            item[this.key] === this.value[this.key] ||
            item[this.field] === this.value[this.field]
        ) || {};
      this.name = find[this.field];
      this.color = find.color || find.colorCode || this.color;
    }
  }
  onChangeValues() {
    this.list = this.list || [];
    if (!this.multiple || !this.list.length) {
      return;
    }
    if (!this.list.length) {
      this.name = this.values.map((item) => item[this.field]).join(", ");
      return;
    }
    this.values = this.values || [];
    let values = [];
    this.values.forEach((value) => {
      const findValue = this.list.find((item) => {
        return value[this.key] === item[this.key] || value === item[this.key];
      });
      if (findValue) {
        values.push(findValue);
        if (!this.isReadOnly(findValue, this.field)) {
          findValue.isCheck = true;
        }
      }
    });
    
    let isChangeObject = this.values[0] && typeof this.values[0] !== "object";
    if (isChangeObject) {
      this.result.emit(values);
      this.valuesChange.emit(values);
    }
    this.values = values;
    this.name = this.values.map((item) => item[this.field]).join(", ");
  }
  isReadOnly(obj, prop) {
    let currentObj = obj;

    while (currentObj) {
      const desc = Object.getOwnPropertyDescriptor(currentObj, prop);
      if (desc) {
        // It is read-only if writable is explicitly false, or if it has a getter but no setter
        return desc.writable === false || (desc.get && !desc.set);
      }
      currentObj = Object.getPrototypeOf(currentObj);
    }
    return false;
  }
  onChangeOptionGroup() {
    if (this.optionGroups.length > 0) {
      this.groups = [];
      this.optionGroups.forEach((option) => {
        const list =
          (this.list || []).filter((item) =>
            option.values.some((value) => value === item[option.field])
          ) || [];
        this.groups.push({
          option,
          list,
          isHide: !list.length,
        });
      });
    }
  }
  cutName() {
    this.name = this.name || "";
    this.cdf.detectChanges();
  }
  writeValue(currentValue: any): void {
    if (typeof currentValue === "object") {
      this.values = currentValue;
      this.onChangeValues();
    } else {
      this.value = currentValue;
      this.onChangeValue();
    }
    this.cutName();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  open() {
    const contentEl = document.getElementById(this.id);
    contentEl.classList.toggle("show");
    if (contentEl.classList.contains("show")) {
      this.showDropdownPortal();
    } else {
      this.hideDropdownPortal();
    }
    // document.getElementById('#backdrop').classList.toggle("show");
    $("#backdrop").toggleClass("show-backdrop");
    $("#backdrop").click(function (e) {
      $("#backdrop").removeClass("show-backdrop");
    });
  }
  private showDropdownPortal() {
    const contentEl = document.getElementById(this.id);
    if (!contentEl || this.contentPlaceholder) {
      return;
    }
    this.contentPlaceholder = document.createComment(
      "dropdown-content-placeholder",
    );
    contentEl.parentElement.insertBefore(this.contentPlaceholder, contentEl);
    document.body.appendChild(contentEl);
    this.positionDropdown();
    window.addEventListener("scroll", this.repositionHandler, true);
    window.addEventListener("resize", this.repositionHandler);
  }
  private hideDropdownPortal() {
    window.removeEventListener("scroll", this.repositionHandler, true);
    window.removeEventListener("resize", this.repositionHandler);
    const contentEl = document.getElementById(this.id);
    if (!contentEl || !this.contentPlaceholder) {
      return;
    }
    this.contentPlaceholder.parentElement.insertBefore(
      contentEl,
      this.contentPlaceholder,
    );
    this.contentPlaceholder.remove();
    this.contentPlaceholder = null;
    contentEl.style.top = "";
    contentEl.style.left = "";
    contentEl.style.width = "";
  }
  private positionDropdown() {
    const contentEl = document.getElementById(this.id);
    const triggerEl = document.getElementById("action" + this.id);
    if (!contentEl || !triggerEl) {
      return;
    }
    if (window.innerWidth <= 480) {
      contentEl.style.top = "";
      contentEl.style.left = "";
      contentEl.style.width = "";
      return;
    }
    const gap = 5;
    const margin = 8;
    const maxWidth = 300;
    const triggerRect = triggerEl.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;

    contentEl.style.width = "";
    const naturalWidth = contentEl.scrollWidth;
    const width = Math.min(
      Math.max(naturalWidth, triggerRect.width),
      maxWidth,
      viewportWidth - margin * 2,
    );
    contentEl.style.width = width + "px";

    const contentRect = contentEl.getBoundingClientRect();

    let left = triggerRect.left;
    if (left + contentRect.width > viewportWidth - margin) {
      left = Math.max(margin, viewportWidth - contentRect.width - margin);
    }

    let top = triggerRect.bottom + gap;
    const fitsBelow = top + contentRect.height <= viewportHeight - margin;
    if (!fitsBelow && triggerRect.top - contentRect.height - gap > margin) {
      top = triggerRect.top - contentRect.height - gap;
    }

    contentEl.style.left = left + "px";
    contentEl.style.top = top + "px";
  }
  debouncSearch() {
    this.debouncSearch$.next(true);
  }
  filter() {
    const filter = this.textSearch.toUpperCase();
    if (this.isEmitSearch) {
      this.emitSearch.emit(filter);
      return;
    }
    if (!this.groups.length) {
      this.list.forEach((item) => {
        const text = (item[this.field] || "").toUpperCase();
        const text1 = DiacriticUtil.removeDiacritics(
          item[this.field] || ""
        ).toUpperCase();
        if (text.includes(filter) || text1.includes(filter) || !filter) {
          item.isHide = false;
        } else {
          item.isHide = true;
        }
      });
    } else {
      this.groups.forEach((group) => {
        group.isHide = true;
        group.list.forEach((item) => {
          const text = (item[this.field] || "").toUpperCase();
          const text1 = DiacriticUtil.removeDiacritics(
            item[this.field] || ""
          ).toUpperCase();
          if (text.includes(filter) || text1.includes(filter) || !filter) {
            group.isHide = false;
            item.isHide = false;
          } else {
            item.isHide = true;
          }
        });
      });
    }
    this.cdf.detectChanges();
  }
  chooseValue(value) {
    if (!this.multiple) {
      document.getElementById(this.id).classList.remove("show");
      this.hideDropdownPortal();
      this.value = value || {};
      this.name = this.value[this.field];
      this.color = this.value.color || this.value.colorCode || this.color;
      this.valueChange.emit(this.value[this.key]);
      this.result.emit(value);
      this.onChange(this.value[this.key]);
    } else {
      this.chooseValues(value);
    }
    this.cutName();
    $("#backdrop").removeClass("show-backdrop");
  }
  chooseValues(value) {
    if (value === this.defaultItem) {
      const filterList = this.list.filter((item) => (!item.isHide));
      if (!this.values.length) {
        this.values = filterList;
        filterList.forEach((item) => (item.isCheck = true));
      } else {
        let findIndex = [];
        filterList.forEach((item) => {
          item.isCheck = false;
          let index = this.values.findIndex(value => value[this.key] === item[this.key]);
          if (index > -1) {
            findIndex.push(index);
          }
        });
        findIndex.reverse().forEach((index) => {
          this.values.splice(index, 1);
        })
      }
    } else {
      const index = this.values.findIndex(
        (item) => item[this.key] === value[this.key]
      );
      if (index === -1) {
        value.isCheck = true;
        this.values.push(value);
      } else {
        value.isCheck = false;
        this.values.splice(index, 1);
      }
    }
    this.name = this.values.map((item) => item[this.field]).join(", ");
    // let values = this.values;
    // if (values.length === this.list.length) {
    //   values = [];
    // }
    this.result.emit(this.values);
    this.valuesChange.emit(this.values);
    this.onChange(this.values);
  }
  chooseGroup(group) {
    this.resultGroup.emit(group);
  }
  checkClick() {
    if (this.isFirstClick) {
      this.isFirstClick = false;
      this.firstClick.emit(true);
    }
  }
  checkSelectAll() {
    const filterList = this.list.filter((item) => (!item.isHide));
    return filterList.some((item) => {
      return (this.values || []).some((value) => {
        return value[this.key] === item[this.key]
      })
    })
  }
}
export class OptionGroup {
  field: string;
  values: any[];
  title: string;
  icon: string;
  constructor(params?) {
    if (!params) {
      return;
    }
    this.field = params.field;
    this.values = params.values;
    this.title = params.title;
    this.icon = params.icon;
  }
}
